module.exports = __webpack_public_path__ + "img/company.fa8f1da4.png";